/* eslint-disable no-unused-labels */
import store from "@/store"
import { utils } from "@/store/helpers"
import router from "@/router"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

// class User {
//   constructor(data) {
//     this.id = null
//     this.name = null
//     this.full_name = null
//     this.first_name = null
//     this.last_name = null
//     this.email = null
//     this.avatar = null
//     for (const [key, value] of Object.entries(data)) {
//       Object.defineProperty(this, key, {
//         value: value,
//       })
//     }
//   }
// }
class Record {
  constructor(record) {
    // if just id is provided
    if (utils.isUUID(record)) {
      //check if its a user
      record = store.state.data.users.find((r) => r.id == record)
      if (!record) {
        // get the record from the server
        record = Record.getRecord(record).then((res) => {
          if (res.data.object_type != "contact") {
            this.is_company = true
          }
          return res.data
        })
      }
    }
    this.data = record
    this.is_user = false
    this.is_company = false
    this.id = record?.id || null
    this.avatar = record?.avatar || null
    this.uuid = record?.uuid || null
    this.values = record?.values || null
    this.parent = record?.parent || null
    this.origin = record?.origin || null
    this.object_type = record?.object_type || null
    this.type = record?.type || null
    this.is_active = record?.is_active || null
    this.merged_values = record?.merged_values || null
    this.object_id = record?.object_id || null
    this.owner = record?.owner || null
    this.key_records = record?.key_records || []
    this.co_owners = record?.co_owner || []
    this.info = {}
    this.list_of_map_ignored_records = record?.list_of_map_ignored_records || []

    this.info = this._info()

    // if the record is a user
    if (!record?.values) {
      this.is_user = true
    } else if (record?.object_type && record?.object_type != "contact") {
      this.is_company = true
    }
  }
  updateMetricValue(metric, metric_new_value) {
    // if the metric is id we get the metric from the store
    if (typeof metric == "string") {
      metric = store.state.metrics.find((m) => m.id == metric || m.reference_name == metric)
    }

    let value = metric_new_value
    // if date before send to server we convert to utc always
    if (metric.data_type == "DateTime" || metric.data_type == "Date") {
      value = utils.convertDateStringFromLocalDateToUtc(value, metric.data_type)
    }
    store
      .dispatch("data/updateRecordMetric", {
        record_id: this.data.id,
        data: {
          prev_value: this.data.values?.[metric.reference_name] || null,
          new_value: value,
          metric: metric.id
        }
      })
      .then((res) => {
        metric.value = metric_new_value

        if (store.state.ui.currentCompany.id == this.data.id) {
          store.dispatch("ui/setCurrentCompany", res.data)
        }

        // update record in the store
        store.commit("data/setRecord", res.data)
        store.$emitter.emit(ALL_EMITTERS.INIT_PHASES_IN_CUSTOMER_JOURNEYS_VIEW)
        store.$emitter.emit(ALL_EMITTERS.INIT_PHASES_IN_JOURNEYS)
        store.$emitter.emit(ALL_EMITTERS.METRICS_CHANGED)
        store.$emitter.emit(ALL_EMITTERS.METRIC_UPDATED_IN_GRAPHS_GRID, metric)
        store.$emitter.emit(ALL_EMITTERS.METRICS_UPDATED_IN_OBJECT_VIEW, metric)

        store.$emitter.emit(ALL_EMITTERS.REFRESH_ROLLUP_METRICS, this.data.id)
      })
      .catch((error) => {
        let error_message = window.$t("Failed to update") + ` ${metric.name} ` + window.$t("metric value. Please try again.")
        if (error?.code == "BAD_REQUEST") {
          error_message = window.$t("Failed to update") + ` ${metric.name} ` + window.$t("metric value") + " .<br>"
          Object.keys(error.errors).forEach((key) => {
            error_message = error_message + " " + error.errors[key] + "<br>"
          })
        }
      })
  }
  static getRecord(id) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("data/getRecord", id)
        .then((res) => {
          return resolve(res.data)
        })
        .catch((err) => {
          return reject(err)
        })
    })
  }
  static getComponentRecord(component) {
    return new Promise((resolve, reject) => {
      if (component.connectTo == "this_record" || !component.connectTo) {
        if (store.state.ui.currentCompany && store.state.ui.currentCompany.id == router.currentRoute.value.params.cid) {
          return resolve(store.state.ui.currentCompany)
        } else {
          // get the current record id from the url
          if (router.currentRoute.value.params.cid) {
            return store
              .dispatch("data/getRecord", router.currentRoute.value.params.cid)
              .then((res) => {
                if (component.connectTo == "this_record" || !component.connectTo) {
                  store.dispatch("ui/setCurrentCompany", res.data)
                  store.dispatch("ui/setCurrentCompanyBreadcrumb", [Record.from(res.data).name])
                }
                return resolve(res.data)
              })
              .catch((err) => {
                return reject(err)
              })
          }
        }
      } else if (component.linkedRecord && component.connectTo == "another_record") {
        return store
          .dispatch("data/getRecord", component.linkedRecord?.id || component.linkedRecord)
          .then((res) => {
            return resolve(res.data)
          })
          .catch((err) => {
            return reject(err)
          })
      } else {
        console.error(`Unhandled component record fetch logic`, component)
        return reject("Unhandled component record fetch logic")
      }
    })
  }
  get phone_number() {
    if (this.is_user) {
      return this.data?.phone_number
    } else {
      return this.info?.phone_number
    }
  }
  get name() {
    if (this.is_user) {
      return this.full_name
    } else {
      return this.info?.name
    }
  }
  get url() {
    if (!this.is_user) {
      if (this.data.parent) {
        return `/portfolio/${this.data.parent_type}/${this.data.parent}/${this.data.type}/${this.data.id}/overview`
      } else {
        return `/portfolio/${this.data.type}/${this.data.id}/overview`
      }
    } else {
      return `/admin/users/${this.data.id}/profile`
    }
  }
  get full_name() {
    if (this.is_user) {
      if (this.data?.full_name) {
        return this.data.full_name
      } else {
        return this.data?.email
      }
    } else {
      if (this.info?.full_name) {
        return this.info.full_name
      } else {
        return this.info?.email
      }
    }
  }

  get first_name() {
    if (this.is_user) {
      if (this.data?.first_name) {
        return this.data.first_name
      } else {
        return this.data?.email
      }
    } else {
      if (this.info?.first_name) {
        return this.info.first_name
      } else {
        return this.info?.email
      }
    }
  }

  get last_name() {
    if (this.is_user) {
      return this.data?.last_name
    } else {
      return this.info?.last_name
    }
  }
  get email() {
    if (this.is_user) {
      return this.data?.email
    } else {
      return this.info?.email
    }
  }
  get logo() {
    if (this.is_user) {
      return this.avatar
    } else if (this.is_company) {
      return `https://logosnap.io/api/${this.domain_name}?token=ecoTB81m5dQqkrjw`
    } else {
      return window.default_avatar
    }
  }
  get domain_name() {
    try {
      if (this.is_user) {
        return this.data?.email?.split("@")[1]
      } else {
        return utils.getDomainName(this.values[utils.getOptionMetricReference(this.type, "website")])
      }
    } catch (error) {
      return null
    }
  }

  open() {
    router.push(this.url)
  }
  openPage() {
    this.open()
  }

  _info() {
    let info = {
      base_renewal_value: 0,
      base_renewal_date: null
    }
    if (this.type == "company") {
      return {
        ...info,
        name: this.data.name || this.values[utils.getOptionMetricReference(this.type, "name")],
        phone_number: this.values[utils.getOptionMetricReference(this.type, "phone_number")],
        industry: null,
        country: null,
        products: null
      }
    } else if (this.type == "department") {
      return {
        name: this.data.name || this.values[utils.getOptionMetricReference(this.type, "name")]
      }
    } else if (this.type == "opportunity") {
      return {
        ...info,
        name: this.data.name || this.values[utils.getOptionMetricReference(this.type, "name")]
      }
    } else if (this.type == "contact") {
      let data = {
        name: this.data.name || this.values[utils.getOptionMetricReference(this.type, "name")],
        phone_number: this.values[utils.getOptionMetricReference(this.type, "phone_number")],
        full_name: this.data.name || this.values[utils.getOptionMetricReference(this.type, "name")],
        first_name: this.values[utils.getOptionMetricReference("contact", "first_name")],
        last_name: this.values[utils.getOptionMetricReference("contact", "last_name")],
        email: this.values[utils.getOptionMetricReference("contact", "email")],
        relationship_strength: this.values["contact_relationship_strength_rs"]
      }
      if (!data.name) {
        data["name"] = `${data.first_name} ${data.last_name}`
        data["full_name"] = `${data.first_name} ${data.last_name}`
      }
      return data
    } else {
      if (this.values) {
        return {
          name: this.values[utils.getOptionMetricReference(this.type, "name")]
        }
      }
    }
  }

  static from(data) {
    return new Record(data)
  }
}

export { Record }
